import { RVDashboardNavigation } from '@/components/ReturnVariance/RVDashboardNavigation'
import { AxiomReportType } from '@/enums/axiom-report.enum'
import { IReturnVarianceReportDailyAttribution } from '@/interfaces/rvReport.interface'
import { ReportDashboardLayout } from '@/Layouts/ReportDashboardLayout'
import VerticallySplitLayout from '@/Layouts/VerticallySplitLayout'
import { getReturnVarianceReportDailyAttribution } from '@/services/axiomReport.service'
import { AgGridReact } from '@ag-grid-community/react'
import { Loader } from '@components/Base/Loader/Loader'
import RVHeader from '@components/ReturnVariance/RVHeader'
import { RVSummaryChart } from '@components/ReturnVariance/RVSummaryChart'
import { RVSummaryTable } from '@components/ReturnVariance/RVSummaryTable'
import { useAppSelector } from '@hooks/use-app-selector'
import { Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const RVSummaryPage: React.FC = () => {
  const navigate = useNavigate()
  const [gridReference, setGridReference] = useState<AgGridReact>()
  const [rowData, setRowData] = useState<
    IReturnVarianceReportDailyAttribution[]
  >([])
  const selectedReport = useAppSelector((s) => s.axiomReport.selectedReport)
  const [showLoader, setShowLoader] = useState(false)

  const fetchRvDailyAttribution = async () => {
    try {
      setShowLoader(true)
      const res = await getReturnVarianceReportDailyAttribution(
        selectedReport.reportId,
      )
      if (res) {
        setRowData(res)
      }
    } catch (error) {
    } finally {
      setShowLoader(false)
    }
  }

  useEffect(() => {
    if (
      Object.keys(selectedReport).length &&
      selectedReport.reportType === AxiomReportType.RV
    ) {
      fetchRvDailyAttribution()
    } else {
      navigate('/')
    }
  }, [selectedReport])

  return (
    <ReportDashboardLayout
      navigation={<RVDashboardNavigation />}
      selectedReport={selectedReport}
    >
      {showLoader ? (
        <Loader />
      ) : (
        <VerticallySplitLayout
          contentTop={<RVSummaryChart chartData={rowData} />}
          contentBottom={
            <RVSummaryTable
              rowData={rowData}
              setGridReference={setGridReference}
            />
          }
          headerTop={
            <Typography variant='h4' data-cy='rvSummary'>
              Summary
            </Typography>
          }
          headerBottom={
            <RVHeader
              reportData={selectedReport}
              gridReference={gridReference as AgGridReact}
            />
          }
        />
      )}
    </ReportDashboardLayout>
  )
}
